import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';

interface SEOData {
  meta_title: string | null;
  meta_description: string | null;
  keywords: string[] | null;
  og_title: string | null;
  og_description: string | null;
  og_image: string | null;
  canonical_url: string | null;
  robots_index: boolean;
  robots_follow: boolean;
  schema_type: string;
}

export const useSEO = () => {
  const location = useLocation();
  const [seoData, setSeoData] = useState<SEOData | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSEO = async () => {
      try {
        const { data, error } = await supabase
          .from('seo_settings')
          .select('*')
          .eq('page_path', location.pathname)
          .single();

        if (error && error.code !== 'PGRST116') { // PGRST116 = no rows returned
          console.error('Error fetching SEO data:', error);
        }

        setSeoData(data || null);
      } catch (err) {
        console.error('SEO fetch error:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchSEO();
  }, [location.pathname]);

  return { seoData, loading };
};
